import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-center justify-between gap-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "text-xs font-bold uppercase tracking-wider text-primary40" }, " O que esta escala exige ", -1)
const _hoisted_3 = {
  key: 0,
  class: "flex flex-wrap gap-2"
}
const _hoisted_4 = {
  class: "mt-1.5 text-sm leading-6 text-textPrimary",
  "data-testid": "qualification-policy-summary-text"
}
const _hoisted_5 = {
  key: 0,
  class: "mt-2 flex flex-col gap-1",
  "data-testid": "qualification-policy-summary-errors"
}
const _hoisted_6 = {
  key: 1,
  class: "mt-1.5 text-xs text-gray-600"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "todos", -1)
const _hoisted_8 = {
  key: 2,
  class: "mt-1.5 text-xs text-gray-600"
}

import { computed } from 'vue'
import { mdiClockOutline, mdiLockOutline } from '@mdi/js'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import { useProfessionalDocumentCatalogStore } from '@/pinia-store/useProfessionalDocumentCatalogStore'
import type { QualificationRuleGroup } from '@/types/qualification-policy.types'

import { countByOnFail, summarizePolicy } from './policyModel'


export default /*#__PURE__*/_defineComponent({
  __name: 'PolicySummary',
  props: {
    policy: {},
    errors: { default: () => [] }
  },
  setup(__props: any) {

const props = __props;



// Só lê o catálogo (nomes por chave); quem carrega é a seção. Sem nome, sai a chave.
const catalog = useProfessionalDocumentCatalogStore()
const text = computed(() => summarizePolicy(props.policy, catalog.reasonName))
const count = computed(() => countByOnFail(props.policy))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["rounded-lg border px-4 py-3 text-left", _ctx.errors.length ? 'border-negative bg-red-50' : 'border-primary10 bg-[#F3F9FB]']),
    "aria-live": "polite",
    "data-testid": "qualification-policy-summary"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (!_ctx.errors.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (count.value.BLOCK)
              ? (_openBlock(), _createBlock(LabelBadge, {
                  key: 0,
                  label: `${count.value.BLOCK} ${count.value.BLOCK === 1 ? 'bloqueia' : 'bloqueiam'}`,
                  color: "red",
                  size: "small",
                  icon: _unref(mdiLockOutline)
                }, null, 8, ["label", "icon"]))
              : _createCommentVNode("", true),
            (count.value.PRE_ALLOCATE)
              ? (_openBlock(), _createBlock(LabelBadge, {
                  key: 1,
                  label: `${count.value.PRE_ALLOCATE} ${count.value.PRE_ALLOCATE === 1 ? 'permite' : 'permitem'} pré-alocação`,
                  color: "orange",
                  size: "small",
                  icon: _unref(mdiClockOutline)
                }, null, 8, ["label", "icon"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(text.value), 1),
    (_ctx.errors.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
            return (_openBlock(), _createElementBlock("li", {
              key: error,
              class: "text-sm text-negative"
            }, _toDisplayString(error), 1))
          }), 128))
        ]))
      : (count.value.PRE_ALLOCATE)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
            _createTextVNode(" Pré-alocação só acontece quando "),
            _hoisted_7,
            _createTextVNode(" os critérios que o médico não atende permitem pré-alocação. Cada pré-alocação abre uma demanda urgente para o Time de Documentação. ")
          ]))
        : (count.value.BLOCK)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Quem não atender será recusado na alocação com a lista do que falta (sem liberação manual). "))
          : _createCommentVNode("", true)
  ], 2))
}
}

})